<div class="container-main">
  <div class="container">
    <div class="row">
      <div class="col-12 form-group">
        <p class="title-me">Sobre mí</p>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <img class="image-main" src="../../../assets/profile.JPG" alt="">
      </div>
      <div class="col-12 col-sm-8 form group">
        <p class="title-about">Alain Nicolás Tello</p>
        <p class="subtitle-about">Ing. en Sistemas Computacionales</p>
        <p class="text-about">
          Hola, soy el Ing. Alain Nicolás Tello, desarrollador android e instructor online. Soy un apasionado de la 
          programación y las buenas prácticas, me encanta aprender todo sobre el desarrollo para android nativo, y es 
          un privilegio poder compartir mis conocimientos con personas de cualquier parte del mundo.
        </p>
        <p class="subtitle-me">Desarrollor Android(Java/Kotlin):</p>
        <p class="text-me">
          Desde 2014 me dedico completamente al desarrollo en esta plataforma, en 2015 y 2016 me certifique 
          en 4 diferentes cursos para el desarrollo apps nativas en Android y móviles en general (iOS y cordova), en la 
          UPV(Universitat Politécnica de València), Galileo Universidad y en UCM(Universidad Complutense de Madrid).
        </p>
        <p class="text-me">
          He participado en proyectos grandes y pequeños con múltiples tecnologías y características en 
          la arquitectura, desarrollando en su mayoría software a la medida y SaaS(Software como un Servicio) para el sector 
          privado principalmente.
        </p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <p class="subtitle-me">Como Instructor</p>
      </div>
      <div class="col-12 col-sm-8 form-group">
        <p class="text-about">
          Cuento con más de 5 años de experiencia como instructor en esta plataforma, y mis más de 120,000 estudiantes con 
          calificaciones de 4.5+ en promedio, me respaldan como un instructor serio a la hora de comprometerse con 
          el aprendizaje rápido y claro, mira las reseñas o preguntas y velo por ti mismo.
        </p>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <p class="text-udemy">Udemy</p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <p class="text-itoo">itoo</p>
      </div>
      <div class="col-12 col-sm-8 form-group">
        <p class="text-about">
          Me uní desde los inicios de esta plataforma, cuento con más de 3mil estudiantes y un servicio de suscripción, 
          todo junto a grandes instructores como Pablo Tillotta, Juan Gabriel Gomilla, Álvaro Chirou, Federico Garay, 
          Ubaldo Acosta, Alvaro Ospina, Agustín Navarro Galdon, y muchos más.
        </p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 col-sm-8 form-group">
        <p class="text-about">
          Desde 2020, me uní al equipo de instructores de frogames, comandado por Juan Gabriel Gomila, mi colaboración 
          es exclusiva para el desarrollo y enseñanza de android.
        </p>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <p class="text-frogames">froGames</p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <img class="image-profile" src="../../../assets/profile2.jpg" alt="">
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <p class="subtitle-me">Experiencia en Front-end:</p>
      </div>
      <div class="col-12 col-sm-8 offset-sm-2 form-group">
        <p class="text-about">
          Iniciando mi carrera en el ambiente laboral, estuve por 3 años en una compañía petrolera, en el departamento 
          de desarrollo e innovación tecnológica como programador front-end con los lenguajes ActionScript 3 y Flex 3 
          para la construcción web de tipo RIA(Rich Internet Application) en el desarrollo de software a la medida.
        </p>
        <p class="text-about">
          A finales de 2015 me introduje al mismo desarrollo de tipo RIA pero ahora con AngularJS como framework 
          principal en conjunto con otras tecnologías(JavaScript, HTML5, CSS, jQuery, etcétera), siguiendo los 
          lineamientos de Material Design.
        </p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <p class="subtitle-me">Mas desarrollo móvil(híbridas y iOS):</p>
      </div>
      <div class="col-12 col-sm-8 offset-sm-2 form-group">
        <p class="text-about">
          Creación de apps para Android y iOS con tecnología web (Phonon + Apache Cordova), creando aplicaciones 
          híbridas para solucionar proyectos de corto alcance y con problemas de capital humano. En enero 2017 también 
          me certifique en el desarrollo de apps nativas para iOS con Swift3.
        </p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 form-group">
        <p class="subtitle-me">Experiencia en el extranjero:</p>
      </div>
      <div class="col-12 col-sm-8 offset-sm-2 form-group">
        <p class="text-about">
          Gracias a las estadías durante mi formación universitaria, tuve la oportunidad de laborar en 2 empresas 
          españolas en 2011 como programador web y encargado de campañas marketing con SEO y Google Adwords. Adicionalmente 
          a esto, también cuento con una estadía en Essen, Alemania, por motivos de capacitación en la universidad de 
          Duisburg-Essen​.
        </p>
      </div>
      <div class="col-12 form-group">
        <hr>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <img class="image-udemy" src="../../../assets/udemy.png" alt="">
      </div>
      <div class="col-12 col-sm-4 form-group">
        <img class="image-itoo" src="../../../assets/itoo.png" alt="">
      </div>
      <div class="col-12 col-sm-4 form-group">
        <img class="image-frogames" src="../../../assets/frogames.png" alt="">
      </div>
      <div class="col-12 col-sm-4 offset-sm-2 form-group">
        <img class="image-cesigsa" src="../../../assets/cesigsa.jpg" alt="">
      </div>
      <div class="col-12 col-sm-4 form-group">
        <img class="image-android" src="../../../assets/android.png" alt="">
      </div>
      <div class="col-12 form-group">
        <p class="text-android">
          "El robot de Android se reproduce o modifica a partir del trabajo generado y compartido por Google, y se usa 
          conforme a lo descrito en la Licencia de Atribución de Creative Commons 3.0".
        </p>
      </div>
    </div>
  </div>
</div>